import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconValidateShield16 = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	viewBox: "0 0 16 16",
	ref,
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "currentColor",
		children: [/* @__PURE__ */ _jsx("path", { d: "m11.07 5.988-1.14-.976-2.542 2.966L5.95 6.9l-.9 1.2 2.562 1.922z" }), /* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M2.5 3.5v6.236c0 .48.23.931.618 1.213l4 2.91a1.5 1.5 0 0 0 1.764 0l4-2.91a1.5 1.5 0 0 0 .618-1.213V3.5A1.5 1.5 0 0 0 12 2H4a1.5 1.5 0 0 0-1.5 1.5M4 9.736V3.5h8v6.236l-4 2.91z",
			clipRule: "evenodd"
		})]
	})
});
const ForwardRef = forwardRef(SvgIconValidateShield16);
export default ForwardRef;
